import { createContext } from 'react';

import type { ContextType } from './types';
import { defaultDispatcher } from './utils/defaultDispatcher';

export const initialState = {
	data: {},
	dispatcher: defaultDispatcher,
};

export const TracktorContext = createContext<ContextType>(initialState);
TracktorContext.displayName = 'TracktorContext';
